(function ($) {

    var m = angular.module('webinarSignUp', ['utils']);

    m.controller('WebinarSignUpFormCtrl', ['$scope', '$http', '$window', '$location', function ($scope, $http, $window, $location) {

        $scope.form = WEBINAR_SIGN_UP_FORM;

        /* Loaded and loading flag */
        $scope.isLoaded = false;
        $scope.isLoading = false;

        $scope.fields = {
            name: getProfileProperty('name'),
            last_name: '',
            second_name: '',
            email: getProfileProperty('email'),
            phone: getProfileProperty('phone'),
            agree: false,
            timezone_offset: -3 - Math.round((new Date()).getTimezoneOffset() / 60) // MSK timezone offset - local timezone offset
        };

        /**
         * @todo move to some other file. dup code
         * @type {Object}
         */
        var groupsDirty = {};
        var watchDirtyFields = [
            'agree'
        ];

        /*
         * @todo move to some other file. dup code
         */
        $scope.$watchGroup(watchDirtyFields.map(function (item) {
            return 'fields.' + item;
        }), function (groups) {
            for (var i in groups) {
                if (groups[i]) {
                    groupsDirty[watchDirtyFields[i]] = true;
                }
            }
        });

        /*
         * @todo move to some other file. dup code
         */
        function getProfileProperty(field) {
            var profile = $scope.form.profile;

            return profile && profile[field] ? profile[field] : null;
        }

        $scope.groupValidationClass = function (fieldName) {
            var control = $scope.webinarSignUpForm[fieldName];

            var obj = {
                'ng-invalid': control.$invalid,
                'ng-dirty': groupsDirty[fieldName]
            };

            return obj;
        };

        $scope.submitErrorList = [];
        $scope.submitErrors = function () {
            return $scope.submitErrorList.join('<br>');
        };

        $scope.submit = function () {

            if (!$scope.webinarSignUpForm.$valid) {
                $scope.submitErrorList = ['Перед отправкой заявки необходимо правильно заполнить поля, выделенные красным'];
                $scope.$emit('submitErrorEvent');
                return;
            }

            $scope.isLoaded = false;
            $scope.isLoading = true;

            if (!$scope.fields.last_name) {
                var name = $scope.fields.name.split(' ');
                if (name.length > 1) {
                    $scope.fields.name = name[0];
                    if (name.length == 2) {
                        $scope.fields.last_name = name[1];
                    } else {
                        $scope.fields.second_name = name[1];
                        $scope.fields.last_name = name[2];
                    }
                }
            }

            // Send to our server
            $http.post(
                $scope.form.url,
                {
                    Profiles: {
                        name: $scope.fields.name,
                        second_name: $scope.fields.second_name,
                        last_name: $scope.fields.last_name,
                        phone: $scope.fields.phone,
                        email: $scope.fields.email
                    },
                    WebinarOrder: {
                        webinar_id: $scope.form.webinarId,
                        channel_advert: $scope.form.channelCode,
                        url_parameters: document.getElementById('urlParameters').value,
                        timezone_offset: $scope.fields.timezone_offset
                    }
                }
            ).then(
                function (data) {
                    $scope.isLoading = false;
                    data = data.data;
                    if (data.errors instanceof Array && data.errors.length == 0) {
                        $scope.isLoaded = true;
                        $('.alert-webinar').show();
                    } else {
                        // @todo: add logging to server
                        $scope.submitErrorList = ['Произошла ошибка отправки, попробуйте еще раз немного позже.<br/>Если ошибка повторяется, напишите нам на <a href="mailto:info@escc.ru">info@escc.ru</a>'];
                        $scope.$emit('submitErrorEvent');
                    }

                },
                function () {
                    // @todo: add logging to server
                    $scope.isLoading = false;
                    $scope.submitErrorList = ['Произошла ошибка отправки, попробуйте еще раз немного позже.<br/>Если ошибка повторяется, напишите нам на <a href="mailto:info@escc.ru">info@escc.ru</a>'];
                    $scope.$emit('submitErrorEvent');
                }
            );
        }
    }]);

    $('.common-form--preloader').removeClass('ng-hide');
})(jQuery);
